import { render, staticRenderFns } from "./Clipboard.vue?vue&type=template&id=5b4825ea&scoped=true&"
import script from "./Clipboard.vue?vue&type=script&lang=js&"
export * from "./Clipboard.vue?vue&type=script&lang=js&"
import style0 from "./Clipboard.vue?vue&type=style&index=0&id=5b4825ea&prod&lang=css&"
import style1 from "./Clipboard.vue?vue&type=style&index=1&id=5b4825ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4825ea",
  null
  
)

export default component.exports